import { render, staticRenderFns } from "./RoleHorizonTempEdit.vue?vue&type=template&id=37ae5482"
import script from "./RoleHorizonTempEdit.vue?vue&type=script&lang=js"
export * from "./RoleHorizonTempEdit.vue?vue&type=script&lang=js"
import style0 from "./RoleHorizonTempEdit.vue?vue&type=style&index=0&id=37ae5482&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports